import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import styled from 'styled-components';
var Container = styled.div({
    width: '100%',
});
var Section = styled.span({
    display: 'inline-block',
    width: '100%',
    backgroundColor: '#eee',
    borderRadius: '4px',
});
export var RecipeCardSkeleton = memo(function () {
    return (_jsxs(Container, { children: [_jsx(Section, { style: { height: '168.75px' } }, void 0), _jsx(Section, { style: { height: '34px', marginTop: '15px' } }, void 0)] }, void 0));
});
